<template>
  <div class="previewbase">
    <p>プレビュー</p>
    <v-col align="right"><v-btn @click.once="back">戻る</v-btn></v-col>
    <v-container>
      <v-form ref="form" v-model="valid">
        <!-- formを表示 -->
        <v-row v-for="(j, j_index) of size" :key="j_index">
          <v-col
            v-for="(i, i_index) of j"
            :key="i"
            :cols="cols(i_index, j_index)"
          >
            <ReportForms :form="value(i_index, j_index)"> </ReportForms>
          </v-col>
        </v-row>
        <!------------------------------------------------------------->
        <v-row>
          <v-col align="left" v-if="data.Report_id != null">
            <v-btn color="primary">削除</v-btn>
          </v-col>
          <v-col align="right">
            <v-btn @click="send" :color="color">送信</v-btn>
          </v-col>
        </v-row>
        <!-- -->
      </v-form>
    </v-container>
  </div>
</template>

<script>
import ReportForms from "./ReportForms";

export default {
  props: {
    //data: Object,
  },
  components: {
    ReportForms,
  },
  data() {
    //console.log(this.data)
    return {
      data: {},
      //
      valid: true,
      productForms: {
        pageID: 0,
        area: [], //this.data.area,
        //delete_area: [],
      },
      size: [],
      color: "blue",
    };
  },
  async mounted() {
    //console.log("PreView Mounted")
    //初期処理
    this.data = JSON.parse(localStorage.getItem("kakanai_preview"));
    this.productForms.area = this.data.area;
    console.log(this.data.area);
    await this.getInit();
    //console.log("PreView Mounted End")
  },
  methods: {
    async getInit() {
      //console.log(this.productForms.area.length)
      //データ数の縦横幅を計算する
      for (let i = 0; i < this.productForms.area[0].length; i++) {
        this.size.push(0);
      }
      for (let i = 0; i < this.productForms.area.length; i++) {
        for (let j = 0; j < this.productForms.area[i].length; j++) {
          //不透明の処理
          if (this.productForms.area[i][j].type == 1) {
            let rules = this.productForms.area[i][j].rule.split(",");
            if (rules[5] == "hide") {
              console.log("不透明");
            }
          }
          if (this.productForms.area[i][j].type != 0) {
            this.size[j]++;
          }
        }
      }
    },
    value(i, j) {
      return this.productForms.area[i][j];
    },
    cols(i, j) {
      return this.productForms.area[i][j].cols;
    },
    back() {
      //history.back();
      alert("プレビュー画面なので閉じてください");
    },
    send() {
      alert("プレビューです");
    },
  },
};
</script>
<style>
/*@import "../../../../css/styles.css";*/
</style>
